import { Box, BoxProps } from "@chakra-ui/react";

const HeaderBg = ({
  headerBgContainerProps,
  image,
  headerImageProps,
}: {
  headerBgContainerProps?: BoxProps;
  image?: string;
  headerImageProps?: BoxProps;
}) => {
  return (
    <Box
      position={"absolute"}
      top={0}
      width={"100%"}
      zIndex={0}
      {...headerBgContainerProps}
    >
      <Box
        width="100%"
        height={{
          base: "120px",
          "2sm": "210px",
          "2lg": "380px",
        }}
        opacity={{
          base: 0.25,
          "2lg": 1,
        }}
        backgroundImage={`url(${image})`}
        backgroundRepeat="no-repeat"
        backgroundPosition="right"
        backgroundSize="contain"
        pointerEvents="none"
        {...headerImageProps}
      />
    </Box>
  );
};

export default HeaderBg;
